import QuestionHoverCard from "./QuestionHoverCard/QuestionHoverCard"
import QuestionPopover from "./QuestionPopover/QuestionPopover"

import { useMediaQueryContext } from "@/provider/MediaQueryProvider"

type Props = {
	contentMessage?: string
	children?: React.ReactNode
}

const QuestionExplanationIcon = ({ contentMessage, children }: Props) => {
	const { isMobile, isIPad } = useMediaQueryContext()
	const usePopover = isMobile || isIPad

	if (children) {
		return (
			<span>
				{usePopover ? (
					<QuestionPopover contentMessage={contentMessage}>
						{children}
					</QuestionPopover>
				) : (
					<QuestionHoverCard contentMessage={contentMessage}>
						{children}
					</QuestionHoverCard>
				)}
			</span>
		)
	} else {
		return (
			<span>
				{usePopover ? (
					<QuestionPopover contentMessage={contentMessage} />
				) : (
					<QuestionHoverCard contentMessage={contentMessage} />
				)}
			</span>
		)
	}
}

export default QuestionExplanationIcon
